import socket from '@/plugins/socket'
import Score from '@/store/model/sport/sport/Score'
import { date } from '@/helpers/format'

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    set: (state, datas) => {
      if (datas) {
        for (const i in datas) {
          const data = datas[i]
          const score = state.list.find(item => item.id === data.id)
          if (score) {
            // Exists => check each data and update if diff
            for (const j in data) {
              if (data[j] !== score[j]) {
                score[j] = data[j]
              }
            }
          } else {
            // Not exists => add
            state.list.push(new Score(data))
          }
        }
      }
    },
    unset: (state, datas) => {
      console.log('return delete', datas)
      if (datas) {
        for (const i in datas) {
          const data = datas[i]
          const index = state.list.findIndex(item => item.id === data.id)
          if (index > -1) {
            state.list.splice(index, 1)
          }
        }
      }
    }
  },
  actions: {
    set (state, data) {
      if (data.sportId > 0 || data.competitionsId > 0 || data.dateStart || data.dateEnd) {
        const parameters = {}

        if (data.dateStart) {
          parameters.dateStart = { column: 'SportSportGame.date', operator: '>=', value: date(data.dateStart) }
        }
        if (data.dateEnd) {
          const dateEnd = new Date(data.dateEnd.getTime())
          dateEnd.setDate(dateEnd.getDate() + 1)
          parameters.dateEnd = { column: 'SportSportGame.date', operator: '<=', value: date(dateEnd) }
        }

        if (data.dayId > 0) {
          parameters['SportSportGame.dayId'] = data.dayId
        } else {
          if (data.groupsTypeId > 0) {
            if (data.groupsTypeId.length === 1) {
              parameters['SportSportGroup.groupTypeId'] = data.groupsTypeId[0]
            } else {
              parameters['SportSportGroup.groupTypeId'] = {
                column: 'SportSportGroup.groupTypeId',
                operator: 'in',
                value: data.groupsTypeId
              }
            }
          }

          if (data.roundsTypeId > 0) {
            if (data.roundsTypeId.length === 1) {
              parameters['SportSportRound.roundTypeId'] = data.roundsTypeId[0]
            } else {
              parameters['SportSportRound.roundTypeId'] = {
                column: 'SportSportRound.roundTypeId',
                operator: 'in',
                value: data.roundsTypeId
              }
            }
          }

          // competition
          if (data.seasonId > 0 || data.competitionsId.length > 0) {
            if (data.seasonId > 0) {
              parameters['SportSportCompetitionseason.seasonId'] = data.seasonId
            }

            if (data.competitionsId.length === 1) {
              parameters['SportSportCompetitionseason.competitionId'] = data.competitionsId[0]
            } else if (data.competitionsId.length > 1) {
              parameters['SportSportCompetitionseason.competitionId'] = {
                column: 'SportSportCompetitionseason.competitionId',
                operator: 'in',
                value: data.competitionsId
              }
            }
          }

          // discipline
          if (data.eventUnitsId > 0) {
            parameters['SportSportRound.eventUnitId'] = {
              value: data.eventUnitsId,
              operator: 'in'
            }
          } else if (data.eventUnitId > 0) {
            parameters['SportSportEventunit.id'] = data.eventUnitId
          } else {
            if (data.categoryId > 0) {
              parameters['SportSportEventunit.categoryId'] = data.categoryId
            }

            if (data.eventId > 0) {
              parameters['SportSportEventunit.eventId'] = data.eventId
            } else if (data.disciplineId > 0) {
              parameters['SportSportEvent.disciplineId'] = data.disciplineId
            } else if (data.sportId > 0) {
              parameters['SportSportDiscipline.sportId'] = data.sportId
            }

            if (data.genderId > 0) {
              parameters['SportSportEventunit.genderId'] = data.genderId
            }
          }
        }

        const parametersCompetitor = Object.assign({}, parameters)
        parametersCompetitor.join = [
          'SportSportScore.competitorId',
          'SportSportCompetitor.gameId',
          'SportSportGame.dayId',
          'SportSportDay.groupId',
          'SportSportGroup.roundId',
          'SportSportRound.competitionSeasonId',
          'SportSportRound.eventUnitId',
          'SportSportEventunit.eventId',
          'SportSportEvent.disciplineId'
        ]
        socket.get('SportSportScore', 'Sport/Score/set', parametersCompetitor)

        const parametersCompetitorPerson = parameters
        parametersCompetitorPerson.join = [
          'SportSportScore.competitorPersonId',
          'SportSportCompetitorperson.competitorId',
          'SportSportCompetitor.gameId',
          'SportSportGame.dayId',
          'SportSportDay.groupId',
          'SportSportGroup.roundId',
          'SportSportRound.competitionSeasonId',
          'SportSportRound.eventUnitId',
          'SportSportEventunit.eventId',
          'SportSportEvent.disciplineId'
        ]

        socket.get('SportSportScore', 'Sport/Score/set', parametersCompetitorPerson)
      }
    },
    post (state, data) { socket.post('SportSportScore', 'Sport/Score/set', data) },
    delete (state, id) { socket.delete('SportSportScore', 'Sport/Score/unset', { id: id }) },
    put (state, data) { socket.put('SportSportScore', 'Sport/Score/set', data) }
  },
  getters: {
    getByCompetitor: (state) => (competitorId) => { return state.list.filter(item => item.competitorId === competitorId) },
    getByCompetitorPerson: (state) => (competitorPersonId) => state.list.filter(item => item.competitorPersonId === competitorPersonId)
  }
}
